// El aviso de "Revisar" nombra un dato que el backend no conoce como "el dato GARMENT_TYPE". La ficha ya tiene los
// nombres de los datos de la categoría ("Tipo de prenda"): se usan esos (prueba en vivo del 5/10,
// ADR-2026-10-06-avisos-de-ml-con-nombres).
export function conNombresDeLaCategoria(mensaje: string, datos: Array<{ id: string; nombre: string }> | null): string {
  if (!datos || datos.length === 0) return mensaje;
  const porId = new Map(datos.map((d) => [d.id, d.nombre]));
  return mensaje.replace(/el dato ([A-Z0-9_]+)/g, (todo, id: string) => {
    const nombre = porId.get(id);
    return nombre ? `«${nombre}»` : todo;
  });
}
